import { useState } from 'react';
import { navigationPrefsOf, type Me, type NavigationPrefs } from '@kaba/shared';
import { api } from '../lib/api';
import { queryClient } from '../lib/board';

export function NavigationSection({ me }: { me: Me }) {
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const prefs = navigationPrefsOf(me.navigationPrefs);
  async function save(key: keyof NavigationPrefs, enabled: boolean) {
    setSaving(true);
    setError('');
    setMessage('Wird gespeichert …');
    try {
      const navigationPrefs = await api.put<NavigationPrefs>('/api/me/navigation-prefs', { [key]: enabled });
      await queryClient.cancelQueries({ queryKey: ['me'] });
      queryClient.setQueryData<Me | null>(['me'], (current) => current?.id === me.id ? { ...current, navigationPrefs } : current);
      setMessage('Navigation gespeichert.');
    } catch (err) {
      setMessage('');
      setError((err as Error).message);
    } finally {
      setSaving(false);
    }
  }
  return (
    <section className="flex flex-col gap-3" aria-labelledby="navigation-heading">
      <h2 id="navigation-heading" className="text-lg font-semibold">Navigation</h2>
      <p className="text-sm text-[var(--ink-soft)]">Wähle, welche zusätzlichen Bereiche in deinem Menü erscheinen.</p>
      <fieldset disabled={saving} className="flex min-w-0 flex-col gap-2">
        <legend className="sr-only">Zusätzliche Bereiche anzeigen</legend>
        {([
          ['showOverview', 'Übersicht anzeigen', 'Kennzahlen und Kalender über deine Boards.'],
          ['showPlanning', 'Tagesplanung anzeigen', 'Aufgaben und Termine im Tages- und Wochenplan.'],
        ] as const).map(([key, label, description]) => (
          <label key={key} className="flex min-h-11 cursor-pointer items-start gap-3 rounded-xl border border-[var(--line)] p-3">
            <input type="checkbox" className="mt-1 size-4 shrink-0" checked={prefs[key]} onChange={(e) => void save(key, e.target.checked)} />
            <span className="min-w-0"><span className="block text-sm font-medium">{label}</span><span className="block text-sm text-[var(--ink-soft)]">{description}</span></span>
          </label>
        ))}
      </fieldset>
      <p className="text-sm text-[var(--ink-soft)]">Gilt nur für dich, auf allen deinen Geräten. Ausblenden entfernt keine Daten; direkte Links funktionieren weiterhin. Ist deine Startansicht ausgeblendet, öffnet sich „Alle Boards“.</p>
      <p role="status" className="text-sm text-[var(--ink-soft)]">{message}</p>
      {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
    </section>
  );
}
